var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8733_41042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.11 11.5992L1.16 15.6992C1.12723 15.8491 1.12836 16.0044 1.16329 16.1538C1.19823 16.3032 1.2661 16.4429 1.36194 16.5627C1.45778 16.6825 1.57917 16.7794 1.71724 16.8462C1.85532 16.9131 2.00659 16.9483 2.16 16.9492C2.23149 16.9564 2.30352 16.9564 2.375 16.9492L6.5 15.9992L14.42 8.10922L10 3.69922L2.11 11.5992Z",
    fill: "#1D3679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9101 4.1595L13.9601 1.2095C13.7662 1.01653 13.5037 0.908203 13.2301 0.908203C12.9565 0.908203 12.6941 1.01653 12.5001 1.2095L10.8601 2.8495L15.2751 7.2645L16.9151 5.6245C17.0111 5.52804 17.0871 5.4136 17.1388 5.28773C17.1905 5.16186 17.2169 5.02703 17.2164 4.89096C17.2159 4.75489 17.1886 4.62024 17.1361 4.49473C17.0835 4.36922 17.0067 4.2553 16.9101 4.1595Z",
    fill: "#1D3679"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8733_41042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.dc9457611a8899dbc13882dbff96ae3d.svg";
export { ForwardRef as ReactComponent };